(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-shop-the-look"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-shop-the-look-block-open]');
  const closeBtn = e.target.closest('[data-shop-the-look-block-close]');
  const content = e.target.closest('.shop-the-look-block__content');
  
  if (openBtn) {
    const btnContent = openBtn.closest('.shop-the-look-block__content');
    const products = btnContent.querySelector('.shop-the-look-block__products');
    const isOpen = btnContent.classList.contains('is-open');
    
    if (isOpen) {
      // Close if already open
      btnContent.classList.remove('is-open');
      products.classList.remove('is-open');
    } else {
      // Open if closed
      btnContent.classList.add('is-open');
      products.classList.add('is-open');
    }
  } else if (closeBtn) {
    const btnContent = closeBtn.closest('.shop-the-look-block__content');
    const products = btnContent.querySelector('.shop-the-look-block__products');
    btnContent.classList.remove('is-open');
    products.classList.remove('is-open');
  } else if (!content) {
    // Close all open products if clicking outside content
    document.querySelectorAll('.shop-the-look-block__content.is-open').forEach((openContent) => {
      const products = openContent.querySelector('.shop-the-look-block__products');
      openContent.classList.remove('is-open');
      products.classList.remove('is-open');
    });
  }
});

// Slider functionality
class ShopTheLookSlider {
  constructor(section) {
    this.section = section;
    this.blocks = section.querySelectorAll('.shop-the-look-block');
    this.currentIndex = 0;
    this.totalBlocks = this.blocks.length;
    this.prevBtn = section.querySelector('[data-shop-the-look-slider-prev]');
    this.nextBtn = section.querySelector('[data-shop-the-look-slider-next]');

    if (this.totalBlocks <= 1) return;

    this.init();
  }

  init() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

    this.updateSlider();
  }

  next() {
    if (this.currentIndex < this.totalBlocks - 1) {
      this.currentIndex++;
      this.updateSlider();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
    }
  }

  updateSlider() {
    // Update CSS variable for translation
    this.section.style.setProperty('--slider-index', this.currentIndex);

    // Update button states
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex === this.totalBlocks - 1;
    }
  }
}

// Initialize sliders
document.querySelectorAll('.shop-the-look-section').forEach((section) => {
  new ShopTheLookSlider(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slider-with-text"] && !Shopify.designMode) return;
  try {
    
// Slider functionality with scrolling and progress bar
class TextWithSlider {
  constructor(section) {
    this.section = section;
    this.sliderContainer = section.querySelector('.slider-with-text__slider');
    this.progressBar = section.querySelector('.slider-with-text__progress-bar');
    this.progressBarContainer = section.querySelector('.slider-with-text__progress-bar-container');
    this.controls = section.querySelector('.slider-with-text__slider-controls');
    this.prevBtn = section.querySelector('[data-slider-with-text-slider-prev]');
    this.nextBtn = section.querySelector('[data-slider-with-text-slider-next]');

    if (!this.sliderContainer) return;

    this.init();
  }

  init() {
    // Handle scroll events for progress bar
    this.sliderContainer.addEventListener('scroll', () => this.updateProgressBar());
    
    // Handle navigation buttons if they exist
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollLeft());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollRight());

    // Check if scrolling is needed and toggle controls/progress bar visibility
    this.checkScrollNeeded();
    
    // Re-check on window resize
    window.addEventListener('resize', () => this.checkScrollNeeded());

    // Initial progress bar update
    this.updateProgressBar();
  }

  checkScrollNeeded() {
    const scrollWidth = this.sliderContainer.scrollWidth;
    const clientWidth = this.sliderContainer.clientWidth;
    const needsScroll = scrollWidth > clientWidth;

    // Hide controls and progress bar if no scrolling is needed
    if (this.controls) {
      this.controls.style.display = needsScroll ? 'flex' : 'none';
    }
    if (this.progressBarContainer) {
      this.progressBarContainer.style.display = needsScroll ? 'block' : 'none';
    }
  }

  updateProgressBar() {
    if (!this.progressBar) return;

    const scrollLeft = this.sliderContainer.scrollLeft;
    const scrollWidth = this.sliderContainer.scrollWidth;
    const clientWidth = this.sliderContainer.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    
    const progress = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
    this.progressBar.style.width = progress + '%';
  }

  scrollLeft() {
    if (!this.sliderContainer) return;
    this.sliderContainer.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollRight() {
    if (!this.sliderContainer) return;
    this.sliderContainer.scrollBy({ left: 300, behavior: 'smooth' });
  }
}

// Initialize sliders
document.querySelectorAll('.slider-with-text').forEach((section) => {
  new TextWithSlider(section);
});

  } catch(e) { console.error(e); }
})();
})();
